import PageBox from "PFComponents/box/page_box";
import DataTable from "PFComponents/data_table/data_table";
import SimplePagination from "PFComponents/pagination/simple_pagination";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./access_requests.module.scss";
import { useAccessRequestsColumns } from "./use_access_requests_columns";

type AccessRequestsPageProps = {
  accessRequests: any;
  isFetching: boolean;
  setPage: (page: number) => void;
};

export const AccessRequestsPage = ({ accessRequests, isFetching, setPage }: AccessRequestsPageProps) => {
  const { t } = useTranslation("admin", { keyPrefix: "accessRequests" });

  const columns = useAccessRequestsColumns();

  return (
    <div className={css.wrapper}>
      <Typography variant="h1" className={css.header}>
        {t("header")}
      </Typography>

      <PageBox isLoading={isFetching}>
        {accessRequests.meta.total > 0 ? (
          <DataTable columns={columns} data={accessRequests.entries} />
        ) : (
          <Typography variant="bodyRegular" className={css.notFound} noMargin>
            {t("accessRequestNotFound")}
          </Typography>
        )}
      </PageBox>

      <SimplePagination
        currentPage={accessRequests?.meta?.page}
        totalPages={accessRequests?.meta?.totalPages}
        handleClick={setPage}
      />
    </div>
  );
};
